// openBlockUserModal.js
'use strict';

import addModal from './addModal.js';
import { MERGE_OPERATION_DATA } from '../ActionTypes.js';

/**
 * Open block user modal
 * @kind action
 * @param {string} {userId} - userId to be blocked.
 * @param {string} {parentModalId} - parent modal id to be closed concurrently (optional).
 * @return {Promise} Action promise.
 */
const openBlockUserModal =
  ({ userId, parentModalId = '' }) =>
  async dispatch => {
    if (!userId) {
      return dispatch({ type: '' });
    }

    dispatch({
      type: MERGE_OPERATION_DATA,
      payload: {
        selectPath: ['blockUserModal'],
        data: {
          userId,
          parentModalId,
        },
      },
    });

    return dispatch(addModal({ id: 'BlockUserModal', prevId: parentModalId }));
  };

export default openBlockUserModal;
